<template>
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item label="用户ID" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.userId" placeholder="请输入用户ID">
						</el-input>
					</el-form-item>
					<el-form-item label="账号" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.username" placeholder="请输入用户账号">
						</el-input>
					</el-form-item>
					<el-form-item label="手机号" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.phone" placeholder="请输入用户手机号">
						</el-input>
					</el-form-item>
					<el-form-item label="收款类型" class='tiny '>
						<el-select v-model="searchInfo.cardType" placeholder="请选择" clear>
							<el-option key="-1" label="全部" value="">全部</el-option>

							<el-option key="1" label="银行卡" :value="1">银行卡</el-option>
							<el-option key="2" label="支付宝" :value="2">支付宝</el-option>
							<el-option key="3" label="微信" :value="3">微信</el-option>
							<el-option key="4" label="提币" :value="4">提币</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="提现状态" class='tiny '>
						<el-select v-model="searchInfo.status" placeholder="请选择" clear>
							<el-option key="-1" label="全部" value="">全部</el-option>

							<el-option key="0" label="待审核" value="0">待审核</el-option>
							<el-option key="1" label="转帐中" value="1">转帐中</el-option>
							<el-option key="2" label="提现成功" value="2">提现成功</el-option>
							<el-option key="3" label="用户撤销" value="3">用户撤销</el-option>
							<el-option key="4" label="驳回" value="4">驳回</el-option>
						</el-select>
					</el-form-item>

					<el-form-item label="更新时间">
						<div class="block">
							<el-date-picker v-model="searchInfo.timer" value-format="yyyy-MM-dd HH:mm:ss"
								type="datetimerange" start-placeholder="开始日期" end-placeholder="结束日期"
								:default-time="['00:00:00', '23:59:59']">
							</el-date-picker>
						</div>
					</el-form-item>

					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button @click="empty">清空</el-button>
							<el-button type="primary" @click="downloadFile">导出</el-button>
						</template>
					</el-form-item>
				</el-form>
				<div style="margin: 20px">
					<div style="font-size: 14px;display: flex;justify-content: start;align-items: center;">
						<div><span style="font-weight: bold">统计：</span></div>
						<div>
							总数量: {{ allData ? allData : 0 | intToFloatfour | cutZero }}
						</div>
					</div>
				</div>
			</header>
		</div>

		<el-table :data="integralWithdrawalList.list" stripe style="width: 100%;" :header-cell-style="headClass"
			v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
			<el-table-column prop="userId" label="用户ID" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="username" label="账号" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="phone" label="手机号" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="realname" label="实名" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="integralName" label="资产名称" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="amount" label="数量" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="fees" label="提现手续费" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="totalPrice" label="到账金额" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			
			<el-table-column prop="totalPrice" label="提现总金额(￥)" align="center" :show-overflow-tooltip="true">
				<template v-slot="scope">
					<span>{{scope.row.totalPrice+scope.row.fees}}</span>
				</template>
			</el-table-column>
			<el-table-column prop="status" label="提现状态" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<div v-if="scope.row.status == 0">待审核</div>
					<div v-if="scope.row.status == 1" style ="color:orange;">转帐中</div>
					<div v-if="scope.row.status == 2" style ="color:green;">提现成功</div>
					<div v-if="scope.row.status == 3">用户撤销</div>
					<div v-if="scope.row.status == 4" style ="color:red;">驳回</div>
				</template>
			</el-table-column>

			<el-table-column prop="cardType" label="收款类型" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<div v-if="scope.row.cardType == 1">银行卡</div>
					<div v-if="scope.row.cardType == 2">支付宝</div>
					<div v-if="scope.row.cardType == 3">微信</div>
					<div v-if="scope.row.cardType == 4">提币</div>
				</template>
			</el-table-column>
			<el-table-column label="收款信息" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<el-button size="small" type="text" @click="queryIntegralWithdrawal(scope.row.id,1,'查 看 收 款 信 息')">查
						看
					</el-button>
				</template>
			</el-table-column>
			<el-table-column prop="linggongStatus" label="灵工状态" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<div v-if="scope.row.linggongStatus == 0">未提交</div>
					<div v-if="scope.row.linggongStatus == 1">待发放</div>
					<div v-if="scope.row.linggongStatus == 2" style ="color:green;">发放成功</div>
					<div v-if="scope.row.linggongStatus == 3" style ="color:red;">发放失败</div>
				
				</template>
			</el-table-column>
			<el-table-column prop="createTime" label="创建时间" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="checkDatetime" label="审核时间" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<div v-if="scope.row.checkDatetime">{{scope.row.checkDatetime}}</div>
					<div v-else>未审核</div>
				</template>
			</el-table-column>
			<el-table-column label="零工发放失败原因" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<el-button size="small" type="text" @click="queryLg(scope.row.linggongReason)">查
						看
					</el-button>
				</template>
			</el-table-column>
			<el-table-column prop="reason" label="驳回原因" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<div v-if="scope.row.reason">{{scope.row.reason}}</div>
					<div v-else>无</div>
				</template>
			</el-table-column>
			
			<el-table-column  label="操作"  fixed="right" align="center"  width="140">
				<template slot-scope="scope">
					<el-button v-if="scope.row.status == 0 && setCheckFlage"  size="small" type="text"
					@click="queryIntegralWithdrawal(scope.row.id,2,'打 款')">通 过</el-button>

					<el-button v-if="(scope.row.status == 0 || scope.row.status == 1) && (setCheckFlage|| setReviewFlage)" 
					size="small" type="text" @click="queryIntegralWithdrawal(scope.row.id,4,'驳 回')">驳 回</el-button>

					<el-button v-if="scope.row.status == 1 && setReviewFlage" size="small" type="text"
					@click="queryIntegralWithdrawal(scope.row.id,3,'打 款')">打款</el-button>

					<!-- <div v-if="scope.row.status != 1 && scope.row.status != 0">不可操作</div> -->
					<el-button v-if="scope.row.status == 2" size="small" type="text"
						@click="showContent(scope.row.systemDocuments)">
						查看打款凭证
					</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination style="margin: 20px;" background :current-page="integralWithdrawalList.pageNum"
			@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper"
			:total="integralWithdrawalList.total" @size-change="handleSizeChange">
		</el-pagination>

		<!-- 查看 -->
		<el-dialog title="打款凭证" :visible.sync="showContentDialog" width="50%" :close-on-click-modal="false">
			<!-- <span v-html="contentValue"></span> -->
			<img v-if="contentValue" :src="contentValue" style="width: 100%;" />
			<span v-else>请上传图片</span>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="showContentDialog = false">关 闭</el-button>
			</span>
		</el-dialog>
		<el-dialog title="零工发放失败原因" :visible.sync="lgDialog" width="50%" :close-on-click-modal="false">
			<!-- <span v-html="contentValue"></span> -->
			<span>{{ contentLgValue }}</span>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="lgDialog = false">关 闭</el-button>
			</span>
		</el-dialog>
		<!-- 查看收款信息 -->
		<el-dialog style="float:rigin" :title="title" :visible.sync="queryDialogVisible" width="50%"
			:close-on-click-modal="false">

			<div class="app-container" style="text-align: center;">
				<el-form size="medium">

					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="收款类别:" class="redItem">
							<div v-if="integralWithdrawal.cardType == 1">银行卡</div>
							<div v-if="integralWithdrawal.cardType == 2">支付宝</div>
							<div v-if="integralWithdrawal.cardType == 3">微信</div>
							<div v-if="integralWithdrawal.cardType == 4">提币</div>
						</el-form-item>

						<el-form-item v-if="integralWithdrawal.cardUserName" label="收款人姓名:" class="redItem">
							{{integralWithdrawal.cardUserName}}
						</el-form-item>

					</div>

					<div style="display: flex;align-items: center;justify-content: space-between;">

						<el-form-item v-if="integralWithdrawal.cardBank" label="开户银行:" class="redItem">
							{{integralWithdrawal.cardBank}}
						</el-form-item>

						<el-form-item v-if="integralWithdrawal.cardSubbranch" label="开户支行:" class="redItem">
							{{integralWithdrawal.cardSubbranch}}
						</el-form-item>
					</div>

					<div style="display: flex;align-items: center;justify-content: space-between;">

						<el-form-item v-if="integralWithdrawal.cardNo" :label="integralWithdrawal.cardType==4?'提币地址:':'账号:'" class="redItem">
							{{integralWithdrawal.cardNo}}
						</el-form-item>
					</div>

					<div style="display: flex;align-items: center;justify-content: space-between;">

						<el-form-item v-if="integralWithdrawal.cardImg" label="收款二维码图片:" label-width="120px">
							<img :src="integralWithdrawal.cardImg" width="60%" />
						</el-form-item>
					</div>

					<div v-if="type == 3"
						style="display: flex;align-items: center;justify-content: space-between;">

						<el-form-item :label-width="formLabelWidth" label="上传凭证:">
							<el-upload class="upload-demo" :action="imgUrl" :on-preview="handlePreview"
								:on-success="onSuccess" :on-remove="handleRemove" :before-remove="beforeRemove" multiple
								:limit="1" :on-exceed="handleExceed" :file-list="fileList">
								<el-button size="small" type="primary">点击上传</el-button>
							</el-upload>
						</el-form-item>

						<el-form-item :label-width="formLabelWidth" label="打款凭证:">
							<template >
								<img v-if="integralWithdrawal.systemDocuments" :src="integralWithdrawal.systemDocuments"
									width="40%" />
								<div v-else>请上传图片</div>
							</template>
						</el-form-item>
					</div>

					<div v-if="type == 4" style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="驳回原因:" class="redItem" style="width: 100%;">
							<el-input style="width: 100%;" v-model="integralWithdrawal.reason" placeholder="请输入驳回原因">
							</el-input>
						</el-form-item>
					</div>
				</el-form>
			</div>
			<div style="text-align: center;">
				<el-button v-if="type == 3" type="primary" @click="remit" :loading="remitLoading">转 帐 完 成</el-button>
				<el-button v-if="type == 2 " type="primary" @click="remitOne" :loading="remitOneLoading">通过</el-button>
				<el-button v-if="type == 4" type="primary" @click="reject" :loading="rejectLoading">驳 回</el-button>
				<el-button type="primary" @click="queryDialogVisible = false">关 闭</el-button>
				<!-- <el-button v-if="type == 2 || type == 3 || type == 4" @click="queryDialogVisible = false">取 消
				</el-button> -->
			</div>
		</el-dialog>

	</div>
</template>

<script>
	import {
		uploadFileServer
	} from "@/api/axios.js";
	var urls = uploadFileServer('integralWithdrawal');

	import {
		quillEditor
	} from 'vue-quill-editor' //调用编辑器
	import 'quill/dist/quill.core.css'
	import 'quill/dist/quill.snow.css'
	import 'quill/dist/quill.bubble.css'
	export default {
		components: {
			//使用编辑器
			quillEditor
		},
		data() {
			return {
				title: '',
				imgUrl: urls,
				fileList: [],
				lgDialog:false,
				contentLgValue:'',
				type: 0,
				loading: false,
				integralWithdrawalList: [], //档位列表
				integralWithdrawal: {},
				rejectDialogVisible: false,
				queryDialogVisible: false,
				mainFormRules: {
					title: {
						required: true,
						message: "请输入账号",
						trigger: "blur"
					},
				},
				ids: '', //id
				formLabelWidth: "200px",
				page: {
					pageNum: 1,
					pageSize: 10
				},
				searchInfo: {
					cardType: '',
					status: '',
				},
				index: null,
				contentValue: "",
				showContentDialog: false,
				allData: {}, //总金额
				txID: '' , //提现数据ID
				remitOneLoading: false,
				userID: '', //登录人ID
				setCheckFlage: false, //是否可以审核
				setReviewFlage: false, //是否可以复核

				remitLoading: false,
				rejectLoading: false,
			};
		},
		computed: {
			editor() {
				return this.$refs.myQuillEditor.quill
			}
		},
		filters: {
			intToFloatfour(val) {
				return (Math.floor(Number(val) * 10000) / 10000).toFixed(4)
			},
			cutZero(old) {
				//拷贝一份 返回去掉零的新串
				old = old + ""
				var newstr = old
				//循环变量 小数部分长度
				var i = 0
				var leng = old.length - old.indexOf(".") - 1
				//判断是否有效数
				if (old.indexOf(".") > -1) {
					//循环小数部分
					for (i = leng; i > 0; i--) {
						//如果newstr末尾有0
						if (newstr.lastIndexOf("0") > -1 && newstr.substr(newstr.length - 1, 1) == 0) {
							var k = newstr.lastIndexOf("0")
							//如果小数点后只有一个0 去掉小数点
							if (newstr.charAt(k - 1) == ".") {
								return newstr.substring(0, k - 1)
							} else {
								//否则 去掉一个0
								newstr = newstr.substring(0, k)
							}
						} else {
							//如果末尾没有0
							return newstr
						}
					}
				}
				return old
			}

		},
		methods: {
			queryLg(e){
				this.lgDialog=true
				this.contentLgValue=e
			},
			downloadFile() {
				let data = {
					userId: this.searchInfo.userId,
					username: this.searchInfo.username,
					cardType: this.searchInfo.cardType,
					status: this.searchInfo.status,
					phone: this.searchInfo.phone,
					startTime: this.searchInfo.timer ? this.searchInfo.timer[0] : "",
					cutOffTime: this.searchInfo.timer ? this.searchInfo.timer[1] : "",
				};
				//   console.log(data);
				this.$api.downloadFileVIPTXExcel(data).then((res) => {
					// console.log(res.data);
					this.showloadFile(res.data);
				});
			},
			showloadFile(res) {
				if (!res) {
					return;
				}
				const link = document.createElement("a");
				let blob = new Blob([res], {
					type: "application/vnd.ms-excel",
				});
				link.style.display = "none";
				link.href = URL.createObjectURL(blob);
				link.setAttribute("download", "提现列表" + ".xls");
				document.body.appendChild(link);
				link.click();
				URL.revokeObjectURL(link.href); // 释放URL 对象
				document.body.removeChild(link);
			},
			reject() {
				this.rejectLoading = true;
				this.$api.integralWithdrawalReject(this.$encrypt(this.integralWithdrawal)).then((res) => {
					// console.log('res', res)
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.queryDialogVisible = false;
						this.findByIntegralWithdrawalList();
					} else {
						this.$message.error(res.message);
					}
					this.rejectLoading = false;
				})
			},
			remitOne(){
				this.remitOneLoading = true;
				
				this.$api.playGame(this.txID).then((res) => {
					// console.log('res', res)
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.findByIntegralWithdrawalList();
						this.queryDialogVisible = false;
					} else {
						this.$message.error(res.message);
					}
					this.remitOneLoading = false;
				})
			},
			remit() {
				// this.$encrypt(this.integralWithdrawal)
				this.remitLoading = true;
				this.$api.haveMoney(this.$encrypt(this.integralWithdrawal)).then((res) => {
					// console.log('res', res)
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.queryDialogVisible = false;
						this.findByIntegralWithdrawalList();
					} else {
						this.$message.error(res.message);
					}
					this.remitLoading = false;
				})
			},
			queryIntegralWithdrawal(e, type, title) {
				this.fileList = [];
				this.title = title;
				this.queryDialogVisible = true;
				this.type = type;
				this.txID = e;
				this.$api.findBuyIntegralWithdrawalId(e).then((res) => {
					res=JSON.parse(this.$decrypt(res.data))
					if (res.state == 'success') {
						this.integralWithdrawal = res.data;
					} else {
						this.$message.error(res.message);
					}
				})

			},
			handleRemove(file, fileList) {
				//console.log(file, fileList);
			},
			handlePreview(file) {
				//console.log(file);
			},
			handleExceed(files, fileList) {
				this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			},
			beforeRemove(file, fileList) {
				return this.$confirm(`确定移除 ${file.name}？`);
			},
			onSuccess(response, file, fileList) {
				// console.log(response);
				var integralWithdrawal = {
					id: this.integralWithdrawal.id,
					cardType: this.integralWithdrawal.cardType,
					cardUserName: this.integralWithdrawal.cardUserName,
					cardBank: this.integralWithdrawal.cardBank,
					cardSubbranch: this.integralWithdrawal.cardSubbranch,
					cardNo: this.integralWithdrawal.cardNo,
					cardImg: this.integralWithdrawal.cardImg,
					systemDocuments: response.message
				}
				this.integralWithdrawal = integralWithdrawal;
			},
			empty() {
				this.searchInfo = {}
			},
			search() {
				this.loading = true
				this.page.pageNum = 1;
				this.findByIntegralWithdrawalList() ;
			},
			showContent(content) {
				this.contentValue = content
				// console.log(this.contentValue)
				this.showContentDialog = true
			},
			//编辑弹框
			headClass() {
				return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
			},
			formartStartDate(row, column) {
				var ymdhis = "";
				if (row) {
					var time = new Date(row.startDate);
					ymdhis += time.getFullYear() + "-";
					ymdhis += ((time.getMonth() + 1) < 10 ? '0' + (time.getMonth() + 1) : (time.getMonth() + 1)) + "-";
					ymdhis += (time.getDate() < 10 ? '0' + time.getDate() : time.getDate()) + ' ';
					ymdhis += (time.getHours() < 10 ? '0' + time.getHours() : time.getHours()) + ":";
					ymdhis += (time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes()) + ":";
					ymdhis += (time.getSeconds() < 10 ? '0' + time.getSeconds() : time.getSeconds());
					return ymdhis;
				} else {
					return '无';
				}
			},
			formartDate(row, column) {
				var ymdhis = "";
				if (row) {
					var time = new Date(row.endDate);
					ymdhis += time.getFullYear() + "-";
					ymdhis += ((time.getMonth() + 1) < 10 ? '0' + (time.getMonth() + 1) : (time.getMonth() + 1)) + "-";
					ymdhis += (time.getDate() < 10 ? '0' + time.getDate() : time.getDate()) + ' ';
					ymdhis += (time.getHours() < 10 ? '0' + time.getHours() : time.getHours()) + ":";
					ymdhis += (time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes()) + ":";
					ymdhis += (time.getSeconds() < 10 ? '0' + time.getSeconds() : time.getSeconds());
					return ymdhis;
				} else {
					return '无';
				}

			},
			pageChange(data) {
				this.page.pageNum = data
				this.findByIntegralWithdrawalList()
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.findByIntegralWithdrawalList()
			},
			findByIntegralWithdrawalList() {
				this.loading = true
				let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,
					username: this.searchInfo.username,
					userId: this.searchInfo.userId,
					phone: this.searchInfo.phone,
					cardType: this.searchInfo.cardType,
					status: this.searchInfo.status,
					startTime: this.searchInfo.timer ? this.searchInfo.timer[0] : "",
					cutOffTime: this.searchInfo.timer ? this.searchInfo.timer[1] : "",
				}
				this.$api.findByIntegralWithdrawalList(this.$encrypt(data)).then((res) => { //提现申请列表
					res=JSON.parse(this.$decrypt(res.data))
					// console.log('数据---', res.data.list[0] )
					if (res.state == 'success') {
						this.integralWithdrawalList = res.data
						this.loading = false
					}
				})
				this.getSumUp(data)
			},
			getSumUp(data){
				this.$api.totalList(this.$encrypt(data)).then((res) => { //提现申请列表
				res=JSON.parse(this.$decrypt(res.data))
				// console.log('总数量1---', res)
					if (res.state == 'success') {
						this.allData = res.data
						// console.log('总数量2---', res.data)
					}
				})
			},
			jurisdiction(){
				let that = this; 
				this.$api.byKey({key:'SYS_CHECK_RECHARGE'}).then(res=>{
					res=JSON.parse(this.$decrypt(res.data))
					if(res.state == 'success'){
						// console.log('可以看见的审核---', res.data.settingValue)
						let arr = res.data.settingValue.split(',')
						this.setCheckFlage = arr.some(item => {
							return item == this.userID
						})
						
						// console.log('能否看见1---', that.setCheckFlage)
					}
				})
				this.$api.byKey({key:'SYS_REVIEW_RECHARGE'}).then(res=>{
					res=JSON.parse(this.$decrypt(res.data))
					if(res.state == 'success'){
						// console.log('可以看见的转账---', res.data.settingValue)
						let arr = res.data.settingValue.split(',')
						this.setReviewFlage = arr.some(item => {
							return item == this.userID
						})
						// console.log('能否看见2---', that.setReviewFlage)
					}
				})
			},
			userInfo(){
				this.$api.getUserInfo(this.$encrypt({})).then(res=>{
					res.data=JSON.parse(this.$decrypt(res.data)).data
					if(res.state == 'success'){
						this.userID = res.data.id;
						this.jurisdiction();
						// console.log('当前用户信息---', res.data.id)
					}
				})
			},
		},
		created() {
			this.findByIntegralWithdrawalList();
		},
		mounted: function() {
			this.userInfo()
		},
	};
</script>

<style>
	.demo-table-expand {
		font-size: 0;
		margin-left: 30px;
	}

	.demo-table-expand label {
		width: 100px;
		color: #99a9bf;
	}

	.demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 50%;
	}

	.lpc-quill img {
		width: 100px;
		height: 120px;
	}

	.lpc-quill-en img {
		width: 100px;
		height: 120px;
	}
</style>
